import { render, staticRenderFns } from "./FieldVersionDict.vue?vue&type=template&id=b1df6cf8&"
import script from "./FieldVersionDict.vue?vue&type=script&lang=ts&"
export * from "./FieldVersionDict.vue?vue&type=script&lang=ts&"
import style0 from "./FieldVersionDict.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports